
import { Component, HostListener, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'pbc-mainlayout',
  templateUrl: './mainlayout.component.html'
})
export class MainLayoutComponent {
  pageTitle: string = 'Platform Battle Editor';
  version: string = environment.version;

  constructor() {
    
  }

  

}



  


// WEBPACK FOOTER //
// ./src/app/layout/mainlayout/mainlayout.component.ts